// src/pages/EditRecipePage.tsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import RecipeForm from '../components/RecipeForm';
import fetchWithAuth from '../utils/fetchWithAuth';
import { useToast } from '../context/ToastContext';

interface RecipeData {
  id: string;
  title: string;
  description: string;
  imageUrl: string;
  servings: number;
  duration: string;
  instructions: string[];
  ingredients: {
    id: string;
    name: string;
    catalogId: number | null;
    quantity: string;
    unitId: string;
    unitLabel: string;
  }[];
  recipeTags: { tag: { id: string } }[]; // adjust if your API shape differs
}

const EditRecipePage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [initialData, setInitialData] = useState<RecipeData | null>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { showToast } = useToast() as any;

  useEffect(() => {
    async function load() {
      try {
        const data: RecipeData = await fetchWithAuth(`/api/recipes/${id}`);
        setInitialData(data);
      } catch (err) {
        showToast({ message: 'Error loading recipe.', type: 'error' });
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [id, showToast]);

  if (loading) return <div>Loading recipe…</div>;
  if (!initialData) return <div>Recipe not found.</div>;

  return (
    <RecipeForm
      initialData={initialData}
      isEditing={true}
      onSuccess={() => navigate(-1)}
    />
  );
};

export default EditRecipePage;
